<script setup lang="ts">
import { computed } from 'vue';

import { formatIban, normalizeIban } from '@peanuds/shared';

import UiCopyToggleButton from '../../UiCopyToggleButton.vue';

const { row, copyable = false } = defineProps<{
  row: { iban?: string | null };
  copyable?: boolean;
}>();

const iban = computed(() => {
  const value = row.iban;
  return typeof value === 'string' ? value.trim() : '';
});

const ibanFallbackText = computed(() => iban.value || '-');
</script>

<template>
  <span :class="{ 'cell-iban': true, 'cell-iban--copyable': copyable }">
    <span class="cell-iban__text">
      {{ iban ? formatIban(iban) : ibanFallbackText }}
    </span>
    <UiCopyToggleButton
      v-if="copyable && iban"
      class="cell-iban__copy"
      tooltip-text="IBAN"
      :copy-text="normalizeIban(iban)"
      icon-dark
      button-size="2rem"
      icon-size="1rem"
    />
  </span>
</template>

<style scoped lang="scss">
.cell-iban {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;

  &--copyable {
    display: inline-flex;
    align-items: center;
    gap: $static-space-2;
    width: 100%;
    min-width: 0;
  }

  &__text {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
